<template>
<div>
	<button @click="$emit('close');">{{str('back')}}</button>
	<div :class="$style.found">{{ 'found' | str }} <strong>{{records.length}}/{{totalRptNum}}</strong></div>
	<datepicker input-class="reportFilterDateInput" :placeholder="str('filter_date')" v-model="reportFilterDate" :language="calendarLang" :disabled-dates="dispabledDates"></datepicker>
	<button :disabled="reportFilterDate==null" @click="clearDate">{{ 'clear_date' | str }} </button>
	<button :disabled="downloadDisabled" @click="downloadRecords">{{ 'download' | str}}</button>
	<button :disabled="!selectedIndex.length" @click="markReadUnread(true)">{{ 'read' | str }} </button>
	<button :disabled="!selectedIndex.length" @click="markReadUnread(false)">{{ 'unread' | str }} </button>
	<div class="reports-container">
		<SortedTable :values="records" class="reports-table" sort="report_date" dir="desc">
			<colgroup>
				<col>
				<col style="width: 45%;">
				<col style="width: 14%;">
				<col style="width: 14%;">
				<col style="width: 9%;">
				<col style="width: 9%;"> 
				<col style="width: 9%;">
            </colgroup>
			<thead>
				<tr>
					<th style="text-align:center;">
						<!-- {{str('select')}} -->
						<input type="checkbox" :class="$style.checkbox" v-model='check_all' @change="toggle_select_all()"/>
					</th>
					<template v-for="(field,index) in fields">
						<th :key="'field_'+index" scope="col" class="noLinkie">						
							<SortLink :name="field">{{str(field)}}</SortLink>
						</th>
					</template>
				</tr>
			</thead>
			<tbody slot="body" slot-scope="sort">
			<template v-for="(rep,rowIndex) in sort.values">
				<tr :key="rowIndex" :class="{active: (rep.isReportRead === 0 || rep.isReportRead === 2)}">
					<td style='text-align:center;'>
						<input type='checkbox' v-if="rep.is_pdf" :class="$style.checkbox" v-model="selected"  @change="toggle_select(rowIndex, rep.id)" @click.shift.left.exact="toggle_select_one(rowIndex, rep.id)" :id="rep.id" :value="rep.id"/>
					</td>
					<td class="limitMaxWidth">
						<span role="link" v-on:click="download(rowIndex)">
						{{local_str(rep, 'name')}}
						{{ rep.docNumber ? '(' + rep.docNumber+')' : ''}}
						</span>	
						<div v-html="displayPreview(rep.preview,rep.keywords,rep.filename)" class="preText"></div>	
						<div class="keyValueText">
						<table v-html="displayKeyValue(rep.preview, rep.keyValue)" v-if="displayPreview(rep.preview,rep.keywords,rep.filename)!==''" padding=0 class="keyValueTable">
						</table>
						</div>		
						<div class="brandlabel">{{rep.brand}}</div>
					</td>
					<td>{{rep.date | date }}</td>
					<td>{{rep.modified | datetime }}</td>
					<td>{{local_str(rep, 'type')}}</td>
					<td style="text-align:center;">{{local_str(rep, 'frequency')}}</td>
					<td style="text-align:center;">{{rep.version}} <span v-if="rep.version >= 2" class="version-alert"><b>!</b></span></td>
				</tr>
				</template>
			</tbody>		
		</SortedTable>

		<div v-if="reports.length==0" :class="$style.noReportsAvailable">{{ 'no_reports_available' | str }}</div>

		<transition name='fade'>
			<div :class="$style.controlDock" v-if="selected.length>0" >
				<!-- <button @click="viewThese">{{str('view')}}</button> -->
				<!-- <button @click="markAsReady">{{str('markAsRead')}}</button> -->
				<!-- <button @click="downloadThese">{{str('download_combined_pdf')}}</button> --> 
			</div>
		</transition>
	</div> 
</div>
</template>

<script>
import api from '@/lib/ServerApi'
import Datepicker from 'vuejs-datepicker';
import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
	name: 'subReportsView',
	props: {
		reports: {
			type: Array,
			required: true
		},
		totalRptNum: {
			type: Number,
			required: false
		},
		language: {
			type: String,
			required: true
		},
		keyword: {
			type: String,
			required: true
		},
		categories: {
			type: Array,	
			required: true
		}
	},
	data: function(){
		return {
			selected: [], // the user's checked items
			selectedIndex: [], // the user's checked item indeice
			check_all: false,
			timeout: null,
			reportFilterDate: null,
			reportFilterDateString: null,
			dispabledDates: {
				customPredictor: this.dispabledDatesEvaluator
			}
		}
	},
	components: {
		Datepicker
	},	
	methods: {
		displayKeyValue: function(previewText, keyVals){
			if(previewText===""){
				return "";
			}
			if(previewText.toUpperCase()==="... FILENAME ..."){
				return "";
			}		
			let splitArr = keyVals.split(",");
			let tableDataToReturn="";
			let count = 0;
			for(let k=0; k<splitArr.length; k++){
				if(splitArr[k].substring(splitArr[k].indexOf(":")+1)!==""){
					if(count%2==0){
						tableDataToReturn = tableDataToReturn + "<tr>";
					}
					tableDataToReturn = tableDataToReturn + "<td>" + splitArr[k].substring(0, splitArr[k].indexOf(":")).bold() + ": ".bold() + splitArr[k].substring(splitArr[k].indexOf(":")+1) + "</td>";
					if(count%2==1){
						tableDataToReturn = tableDataToReturn + "</tr>";
					}
					count++;
				}
			}
			if(tableDataToReturn[tableDataToReturn.length-2]==="d"){
				tableDataToReturn = tableDataToReturn + "</tr>";
			}
			return tableDataToReturn;
		},
		displayPreview: function(previewText, keyWords, nameOfFile){
			let filenameSearch = false;
			keyWords = keyWords.trim();
			if(previewText === ""){
				return "";
			}
			if(keyWords.charAt(0)==="*"){				
				keyWords = keyWords.substring(1);
			}
			if(keyWords.charAt(keyWords.length-1)==="*"){				
				keyWords = keyWords.substring(0, keyWords.length-1);
			}
			previewText = "... "+previewText+" ...";
			keyWords = keyWords.split(" ");
			let searchedKeyword = "";
			if(previewText.toUpperCase()==="... FILENAME ..."){
				previewText=nameOfFile;
				filenameSearch = true;
			}
			for(let j=0; j<keyWords.length; j++){
				searchedKeyword = keyWords[j];
				if(searchedKeyword === ""){
					continue;
				}
				for(let i=0; i<previewText.length-searchedKeyword.length+1; i++){
					
					if(previewText.substring(i, i+searchedKeyword.length).toUpperCase()===searchedKeyword.toUpperCase()){

						if(filenameSearch){							
							previewText = previewText.substring(0,i) + previewText.substring(i, i+searchedKeyword.length).bold() + previewText.substring(i+searchedKeyword.length);
							i = i+searchedKeyword.length+7;
							continue;
						}
						
						let k=i;
						let l=i+searchedKeyword.length-1;
														
						while(!(previewText.charAt(k)===' '||previewText.charAt(k)==='\n'||previewText.charAt(k)==='\t')){
							k--;
						}
														
						while(!(previewText.charAt(l)===' '||previewText.charAt(l)==='\n'||previewText.charAt(l)==='\t')){
							l++;
						}							
													
						previewText = previewText.substring(0,k+1) + previewText.substring(k+1,l).bold() + previewText.substring(l);
						i = l+7;
						
					}
				}
				
			}
			return previewText;
		
		},
		local_str: function(obj, key) {
			return this.$Localization.objStr(obj, key);
		},        
		str: function(val) {
			return this.$Localization.str(val);
		},		
		download: function(index) {
			const val = this.records[index];
			api.download(val.id).then(function(response){												
				this.openFile(response.url);
				if (this.reportFilterDate === null) {
					this.reports[index].isReportRead = 1;
				} else {
					this.records[index].isReportRead = 1;
				}
			}.bind(this));
		},
		viewThese: function(){
			console.log('viewThese',this.selected)
		},
		downloadThese: function() {				
			if(this.selected.length>100) {
				alert("Please select fewer than 100 reports. | Veuillez sélectionner moins de 100 rapports.");
			}
			else {
				this.$api.downloadCombined(this.selected).then(function(response){
					this.openFile(response.url);
					this.selected.forEach((id) => {
					const index = this.reports.findIndex((record) => record.id === id);
					this.reports[index].isReportRead = 1;
				});
					this.select_none();
				}.bind(this));
			}
		},

       downloadRecords: function() {
			var records = []	
			if (this.selected.length === 0) {
				for(let i=0; i<this.records.length; i++){
					records.push(this.records[i].id)
				}
			} else {
				this.selectedIndex.forEach((i) => {
					records.push(this.records[i].id)
				});
			}
			if(records.length > 100) {
				alert("Please select fewer than 100 reports. | Veuillez sélectionner moins de 100 rapports.");
				this.select_none();
			} else {
				this.$api.downloadCombined(records, this.buildFilenameForDate(records[0])).then(function(response){
					this.openFile(response.url);
					if (this.selected.length === 0) {
						for(let i=0; i<this.records.length; i++){
							this.records[i].isReportRead = 1;
						}
					} else {
						this.selected.forEach((id) => {
							const index = this.reports.findIndex((record) => record.id === id);
							this.reports[index].isReportRead = 1;
						});
					}
					this.select_none();
				}.bind(this));
			}
		},		
       buildFilenameForDate: function(recordId) {
			var record;
			for (var i = this.records.length - 1; i >= 0; i--) {
				if(this.records[i].id == recordId) {
					record = this.records[i];
					break;
				}
			}
			var name = record.filename.substring(0,record.filename.indexOf('_', 17));
			name += '_' + record.date + '_combined.pdf';
			return name;
		},
		downloadCombinedReportsForDate: function() {
			var records = []
			for(let i=0; i<this.records.length; i++){
				records.push(this.records[i].id)
			}
			this.$api.downloadCombined(records, this.buildFilenameForDate(records[0])).then(function(response){
				this.openFile(response.url);
				for(let i=0; i<this.reports.length; i++){
					this.reports[i].isReportRead = 1;
				}
				this.select_none();
			}.bind(this));
		},
		markReadUnread: function(isMarkRead) {
			const self = this;
			this.$api.markReadUnread(this.selected, isMarkRead).then(function(){
				self.selected.forEach((id) => {
					const index = self.reports.findIndex((record) => record.id === id);
					self.reports[index].isReportRead = isMarkRead ? 1 : 0;
				});
				self.select_none();
			}.bind(this));
		},
		markAsReady: function(){
			console.log('markAsReady',this.selected)
		},
		toggle_select_all: function(){
			if(this.check_all===true){
				this.select_all();
			}else{
				this.select_none();
			}
		},
		toggle_select: function(rowIndex, reportId){			
			var isSelected = document.getElementById(reportId).checked;			
			if(isSelected){
				if(!this.selectedIndex.includes(rowIndex)){	
					this.selectedIndex.push(rowIndex);
				}
			}else{
				if(this.selectedIndex.includes(rowIndex)){	
					const index = this.selectedIndex.indexOf(rowIndex);
					this.selectedIndex.splice(index,1);
				}
			}					
		},
		toggle_select_one: function(rowIndex, reportId){			
			var isSelected = document.getElementById(reportId).checked;				
			if(isSelected){
				if(!this.selectedIndex.includes(rowIndex)){	
					this.selectedIndex.push(rowIndex);
				}
			}else{
				if(this.selectedIndex.includes(rowIndex)){	
					const index = this.selectedIndex.indexOf(rowIndex);
					this.selectedIndex.splice(index,1);
				}
			}			
			let index0 = 99999;
			for(let j=0; j< this.selectedIndex.length; j++){
				if(this.selectedIndex[j] < index0) index0 = this.selectedIndex[j];
			}					
			if(isSelected && (index0 < rowIndex)){				
				for(let i=index0; i<=rowIndex; i++){						
					var record = this.records[i];		
					document.getElementById(record.id).checked = true;									
					if(!this.selected.includes(record.id)){
						this.selected.push(record.id)
					}
					if(!this.selectedIndex.includes(i)){	
						this.selectedIndex.push(i);
					}
				}
			}								
		},
		select_all: function(){
			this.selectedIndex = [];
			this.selected = [];
			for(let i=0; i<this.records.length; i++){
				var record = this.records[i];
				this.selected.push(record.id)
				this.selectedIndex.push(i);
			}
		},
		select_none: function(){
			this.selectedIndex = [];
			this.selected = [];
		},     
		isPDF: function(string){
			return string.toLocaleLowerCase().includes(".pdf");
		},
		dispabledDatesEvaluator: function(date) {
			var dateString = this.formatDateString(date);
			return this.validReportDates[dateString]!==true;
		},
		clearDate: function() {
			this.reportFilterDate = null;
			this.reportFilterDateString = null;
		},
		formatDateString: function(date) {
			var month = '' + (date.getMonth() + 1);
			var day = '' + date.getDate();
			var year = date.getFullYear();

			if (month.length < 2) 
				month = '0' + month;
			if (day.length < 2) 
				day = '0' + day;

			return year + '-' + month + '-' + day;
		},
		openFile(url) {
            let appUrl = url.replace(/&/g, "TOYOTA");				
            if(appUrl.toLowerCase().includes(".pdf")){
				var keywords;
				if(this.keyword){
					var keyword1 = this.keyword.replace(/\*/g, '');
					var keyword2 = keyword1.replace(/&/g, '');
					keywords = keyword2.replace(/\sAND\s/ig, '');	
				}			
				window.open('lib/web/viewer.html'+'?url='+appUrl+'&keyword='+keywords);		
			}else{
                window.open(url);
			}						
        },
		filter_selection: function(){
			var filteredSelection = [];
			for(let i=0; i<this.records.length; i++){
				var record = this.records[i];
				if(this.selected.includes(record.id)){
					filteredSelection.push(record.id);
				}
			}

			this.selected = filteredSelection;
		}


	},
	computed: {
		fields: function(){
			var fields = [
				'report_name',
				'report_date',
				'modified_date',
				'type',
				'frequency',
				'version',
			];
			return fields;
		},
		records: function(){
			var records = [];

			var dateString = this.reportFilterDate ? this.formatDateString(this.reportFilterDate) : null;

			for(let r=0; r<this.reports.length; r++){
				var record = this.reports[r];

				if(dateString==null || record.date===dateString) {
					record['report_name'] = this.local_str(record, 'name');
					record['report_date'] = record.date;
					record['modified_date'] = record.modified;
					record['type'] = this.local_str(record, 'type');
					record['frequency'] = this.local_str(record, 'frequency');
					record['is_pdf'] = this.isPDF(record.filename);
					records.push(record);
				}
			}

			return records;
		},
		current_language: function(){
			return this.language
		},
		calendarLang: function() {
			return this.language=='fr' ? fr : en;
		},
		validReportDates: function() {
			var dateStrings = {}
			for (var i = 0; i < this.reports.length; i++) {
				dateStrings[this.reports[i].date]=true;
			}
			return dateStrings;
		},
		downloadDisabled: function() {
			var self = this;
			if (self.reportFilterDate==null) {
				return !self.selected.length;
			}
			return false;
		}
	},
	watch: {
		current_language: function(){
		},
		selected: function(){			
			var self = this;
			var checkedAll = (self.selected.length == self.records.length);
			self.check_all = checkedAll;  	       
		},
reportFilterDate: function(){
			var self = this;
			if(self.reportFilterDate!=null){
				self.filter_selection()
			}
			var checkedAll = (self.selected.length == self.records.length);
			self.check_all = checkedAll;  
		}
	}
}
</script>

<style module>

.found {
	font-size: 0.8em;
	padding: 2px 10px;
	display: inline-block;
	width: 100px;
}

.controlDock{
	position: fixed; 
	bottom: 15px; 
	right: 15px;
}

.controlDock button{
	display: block;
	font-size: 10pt;
	font-weight: normal;
	padding: 1px 5px;
	border-radius: 3px;
	margin: 3px;
	width: 100px;
}

.checkbox{
	height: 15px;
	width: 15px;
}
.brandlabel {
	font-weight: bold;
	/*font-style: italic;*/
	margin-top: 5px;
	color: #aaa;
}
button {
	margin-bottom: 2px;
	margin-right: 5px; 
}
button:disabled {
	color: #bbb;
	background: #eee;
}

.noReportsAvailable {
	padding: 80px 50px;
	text-align: center;
	border: 1px solid rgb(243,243,243);
}
</style>

<style type="text/css">
	.reportFilterDateInput {
		max-width: none !important;
		width: 100px;
	}
</style>

<style lang="scss">
@import "@/_variables.scss";

.version-alert {
	color: $toyota;
}
tr.active {
    font-weight: bold;
	color: #666;
	background-color: #ddebf7;

}
.preText{
	margin-top:5px;
	font-weight: normal;
	font-size: 0.9em;
}
.keyValueText{
	
	font-weight: normal;
}
.limitMaxWidth{
	max-width:200px;
	word-wrap: break-word;
}
.keyValueTable{
	margin-top: 5px;
	width: 100%;
	
}
.keyValueTable td{
	padding: 0;
	border: 0;
	width: 50%;
	font-size:0.9em;
	word-wrap: break-word;
	word-break:break-all;
	font-weight: normal;
}
</style>
